import { NgClass, NgStyle } from '@angular/common';
import { Component, ElementRef, Input, OnInit, ViewChild, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ChatbotConfig } from '@shared/index';
import { BsModalService } from 'ngx-bootstrap/modal';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TextareaAutoresizeDirective } from 'src/app/shared/directives/textareaautoresize.directive';
import { AudioToTextService } from 'src/app/shared/services/audio-to-text/audio-to-text.service';
import { InactiveBotServiceService } from '@shared-angular/services/inactive-bot-service.service';
import { LanguageService } from '@shared-angular/services/language.service';
import { PlayAudioService } from 'src/app/shared/services/playaudio.service';
import { SpeechService } from 'src/app/shared/services/speech.service';
import { VoiceBarsComponent } from "../../../../../routes/ai-bot/avatar/voice-bars/voice-bars.component";
import { Speech2Service } from './../../../../services/speech2/speech2.service';

@Component({
  selector: 'app-bot-prompt',
  imports: [NgClass, NgStyle, FormsModule,
    TooltipModule,
    VoiceBarsComponent,
    TextareaAutoresizeDirective
  ],
  templateUrl: './bot-prompt.component.html',
  styleUrl: './bot-prompt.component.scss',
  providers: [BsModalService]
})
export class BotPromptComponent implements OnInit {

  public readonly botConfig = input.required<ChatbotConfig>();
  public readonly isThinking = input.required<boolean>();
  public readonly isSending = input<boolean>(false);

  @Input({ required: true }) public promptInput: string = '';
  public readonly cancelThinking = input.required<boolean>();
  public readonly voiceInput = input.required<boolean>();
  public readonly switchToAvatar = input<boolean>(false);
  public readonly switchToChat = input<boolean>(false);
  public readonly switchToVoice = input<boolean>(false);
  public readonly promptInputChange = output<string>();
  public readonly sendPrompt = output();
  public readonly stfu = output();

  @ViewChild("botPromptInput") protected promptTextarea!: ElementRef<HTMLTextAreaElement>;

  public selectedImageFiles: { name: string, base64: string }[] = [];

  constructor(
    public speechService: SpeechService,
    public speech2: Speech2Service,
    public playService: PlayAudioService,
    public langService: LanguageService,
    public attService: AudioToTextService,
    private modalService: BsModalService,
    private inactiveService: InactiveBotServiceService
  ) {
    this.promptInputChange.subscribe((_transcript: string) => {
      this.inactiveService.botWasActive();
    });
  }

  public ngOnInit(): void {
    this.attService.textReceived.subscribe((text: string) => {
      this.promptInput = text;
      this.promptInputChange.emit(text);
    });
  }

  public onKey(e: KeyboardEvent) {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      e.stopPropagation();
      if (this.isThinking()) return;
      this.promptTextarea.nativeElement.style.height = '44px';
      // TODO: The 'emit' function requires a mandatory void argument
      this.sendPrompt.emit();
    }
  }

  public onPaste(_e: ClipboardEvent) {
    setTimeout(() => {
      window.RAGAI.EVENTS._trigger_RAGAI_EVENT("RAGAI.MSG.pasteToPromptInput", { input: this.promptInput });
    }, 50);
  }



  public deleteImageFromSelection(index: number) {
    this.selectedImageFiles.splice(index, 1);
  }

  public startChatRec() {
    if (this.speechService.speechInputEnabled) {
      this.speechService.isInConversationMode = true;
      this.speechService.isListening = true;
      this.speechService.start();
    }
  }

  public stopChatRec() {
    this.speechService.isInConversationMode = false;
    this.speechService.stop();
  }

  public startSingleRec() {
    this.attService.startRecording();
    /*  if (this.speechService.speechInputEnabled) {
       this.speechService.isListening = true;
       this.speech2.record(false);
     } */
  }

  public stopSingleRec() {
    /*  this.speech2.stop();
     this.speechService.stop();
     this.speechService.isListening = false; */
  }

  public cancelMsgThinking() {
    if (this.isThinking()) {
      // TODO: The 'emit' function requires a mandatory void argument
      this.stfu.emit();
    }
  }
}
